import styled from '@emotion/styled/macro'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel'
import * as React from 'react'

const StyledButton = styled(PrimaryButton)`
  min-width: 48px;
  width: 48px;
  height: 48px;
`
const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.neutralLighter};
`

export const Launcher: React.FunctionComponent = () => {
  const [isPanelVisible, setPanelVisible] = React.useState(false)
  const showPanel = React.useMemo(
    () => () => setPanelVisible(true),
    [setPanelVisible]
  )
  const hidePanel = React.useMemo(
    () => () => setPanelVisible(false),
    [setPanelVisible]
  )

  return (
    <Container>
      <StyledButton
        onClick={showPanel}
        iconProps={{ iconName: 'WaffleOffice365' }}
      />
      <Panel
        isOpen={isPanelVisible}
        type={PanelType.smallFixedNear}
        onDismiss={hidePanel}
        headerText="Make your choice!"
        isLightDismiss={true}
        isBlocking={true}
      />
    </Container>
  )
}

export default Launcher
